/**
 * 找队友（聚合页）：把「开始匹配 / 候选人池 / 组队大厅」三条路收进一个页的三个 Tab。
 *
 * 背景：这三块原本是三个顶层导航入口，规则各不相同（AI 推荐 / 自己录人 / 浏览申请），
 * 用户要自己理解该走哪条。聚合后一条导航进来，Tab 里按需切换：
 *   - 开始匹配：AI 互补推荐（MatchPage embedded 模式，不重复标题）；
 *   - 候选人池：录入/管理候选人（CandidatesPanel 复用）；
 *   - 组队大厅：浏览招募卡申请入队（TeamHallPanel 复用）。
 * 旧路由 /match /candidates /hall 保留独立页形态（收藏链接不失效），导航只留这一个入口。
 */
import { useState } from 'react';

import { CandidatesPanel } from './Candidates.js';
import { MatchPage } from './Match.js';
import { TeamHallPanel } from './TeamHall.js';

type FindTab = 'match' | 'candidates' | 'hall';

const TABS: { id: FindTab; label: string; hint: string }[] = [
  { id: 'match', label: '开始匹配', hint: 'AI 互补推荐，每条都有可解释理由' },
  { id: 'candidates', label: '候选人池', hint: '录入与管理候选人画像' },
  { id: 'hall', label: '组队大厅', hint: '浏览招募卡，一键申请入队' },
];

export function FindTeammatesPage() {
  const [tab, setTab] = useState<FindTab>('match');
  const active = TABS.find((item) => item.id === tab) ?? TABS[0]!;

  return (
    <div className="stack">
      <div className="page-head">
        <div>
          <h1 className="page-title">找队友</h1>
          <p className="page-sub">一条入口三条路：AI 推荐、自己挑人、逛大厅申请——按你的情况选就行。</p>
        </div>
      </div>

      <div className="tab-scroll" role="tablist" aria-label="找队友方式切换">
        {TABS.map((item) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={tab === item.id}
            className={tab === item.id ? 'chip on' : 'chip'}
            onClick={() => setTab(item.id)}
          >
            {item.label}
          </button>
        ))}
        <span className="field-hint">{active.hint}</span>
      </div>

      {tab === 'match' ? <MatchPage embedded /> : null}
      {tab === 'candidates' ? <CandidatesPanel /> : null}
      {tab === 'hall' ? <TeamHallPanel /> : null}
    </div>
  );
}
